import * as random from "./random";

export const randomID = param => {
    return new Date().getTime() + "" + random.range(1111, 9999);
}
